import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { RatingDesktop } from './RatingDesktop';
import { RatingMobile } from './RatingMobile';
import { TRatingColor } from './types';

export interface IRatingProps {
  rating: number;
  countText: string;
}

const HIGH_RATING_THRESHOLD = 4;

export const Rating = ({ rating, countText }: IRatingProps): React.JSX.Element => {
  const color: TRatingColor = rating >= HIGH_RATING_THRESHOLD ? 'decorative-orange' : 'text-secondary-default';
  const score = rating.toFixed(1).replace('.', ',');

  return (
    <>
      <Responsive phone tablet>
        <RatingMobile color={color} countText={countText} score={score} />
      </Responsive>
      <Responsive desktop>
        <RatingDesktop color={color} countText={countText} score={score} />
      </Responsive>
    </>
  );
};
